import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgToastService } from 'ng-angular-popup';
import { AuthService } from 'src/app/services/auth.service';
import { HomeService } from 'src/app/services/home.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-headermobile',
  templateUrl: './headermobile.component.html',
  styleUrls: ['./headermobile.component.scss']
})
// reverted
export class HeadermobileComponent implements OnInit {
  isLogin: any;
  notLength: any;
  logoSrc: string = '../../../assets/GoldBharatone.png'; // Default logo
  showLoginButton: boolean = true; // Controls visibility of login button
  headerBackgroundColor: string = '#010A43'; // Default background color
  dubaiSrc: string = ''; // Holds Dubai Arabic image source
  showDubaiArabic: boolean = false; // Controls visibility of Dubai Arabic image
  
  constructor(
    private toast: NgToastService,
    private auth: AuthService,
    private home: HomeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.checkLoginStatus();
    
    this.auth.loginStatus$.subscribe(() => {
      this.checkLoginStatus();
    });

    // Subscribe to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateUI(event.url);
    });

    // Initial UI check (for direct page reloads)
    this.updateUI(this.router.url);
  }

  updateUI(currentUrl: string) {
    if (currentUrl.includes('/mobile/ui')) {
      // Show Gold Emirates and Dubai Arabic logos
      this.logoSrc = '../../../assets/Gold Emirates3.png'; 
      this.dubaiSrc = '../../../assets/dubaiarabic.png'; 
      this.headerBackgroundColor = '#002B18'; // Change background color
      this.showLoginButton = false; // Hide login button
      this.showDubaiArabic = true; // Show Dubai Arabic image
    } else if (currentUrl.includes('/mobile/mobileview')) {
      // Show only Gold Bharatone logo
      this.logoSrc = '../../../assets/GoldBharatone.png'; 
      this.dubaiSrc = ''; // Hide Dubai Arabic image
      this.headerBackgroundColor = '#010A43'; // Default background color
      this.showLoginButton = true; // Show login button
      this.showDubaiArabic = false; // Hide Dubai Arabic image
      
    }
  }
  

  checkLoginStatus() {
    const tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
    let userToken = null;
    
    for (const key of tokenKeys) {
      userToken = localStorage.getItem(key);
      if (userToken) break;
    }
    
    this.isLogin = userToken !== null;
    
    if (this.isLogin) {
      this.getNotification();
    }
  }

  getNotification() {
    this.home.getNotification().subscribe((res: any) => {
      this.notLength = res.unreadLength;
    });
  }
}